import React from "react";
import { Link } from "react-router-dom";
import Footer from "../../../footer.js";
import "bootstrap/dist/css/bootstrap.min.css";
import Header from "../../../header/header.js";
import Navvbar from "../../../header/Navvbar.js";
const Coupon = () => {
    return (
        <>
            {/* Logo */}
            <Header />
            <Navvbar/>
            <br />

            <div style={{width: '95%',  margin: '0 auto' ,padding:"0px"}}>
                <div className="row">
                    {/* Sidebar */}
                     <div className="col-md-2" style={{ borderRight: '1px solid #004aad'  }}>
                                                 <h3>Promotions</h3>
                                                 <div>
                                                     <div style={{ marginBottom: "10px" }}>
                                                         <Link to="/website" style={{ textDecoration: 'none',color: '#004aad',  fontWeight: '500',marginBottom: '10px',marginLeft:"15px"}}>DDX Websites</Link>
                                                     </div>
                                                     <div style={{ marginBottom: "10px" }}>
                                                         <Link to="/ddxAdd" style={{ textDecoration: 'none',color: '#004aad',  fontWeight: '500',marginBottom: '10px',marginLeft:"15px"}}>DDX Ads</Link>
                                                     </div>
                                                     <div style={{ marginBottom: "10px" }}>
                                                         <Link to="/coupon" style={{ textDecoration: 'none',color: '#004aad',  fontWeight: '500',marginBottom: '10px',marginLeft:"15px"}}>DDX Coupons</Link>
                                                     </div>
                                                     <div style={{ marginBottom: "10px" }}>
                                                         <Link to="/widgets" style={{ textDecoration: 'none',color: '#004aad',  fontWeight: '500',marginBottom: '10px',marginLeft:"15px"}}>Widgets</Link>
                                                     </div>
                                                     <div style={{ marginBottom: "10px" }}>
                                                         <Link to="/action" style={{ textDecoration: 'none',color: '#004aad',  fontWeight: '500',marginBottom: '10px',marginLeft:"15px"}}>Links</Link>
                                                     </div>
                                                     <div style={{ marginBottom: "10px" }}>
                                                         <Link to="/ddxAccount" style={{ textDecoration: 'none',color: '#004aad',  fontWeight: '300',marginBottom: '10px',marginLeft:"15px",fontSize:"15px"}}>DDX Account Onboarding</Link>
                                                     </div>
                                                 </div>
                                             </div>

                    {/* Main Content */}
                    <div className="col-md-10">
                        {/* Header */}
                        <h2>Labnext Coupons</h2>

                        {/* Info Message */}
                        <div
                            className="alert alert-info d-flex justify-content-between align-items-center w-50"
                            style={{ backgroundColor: "#004aad", color: "white" }}
                        >
                            <span>
                                Coupons are not currently enabled.{" "}
                                {/* <a href="#" style={{ color: "white" }}>
                                    Click here to enable them.
                                </a> */}
                            </span>
                        </div>

                        {/* Search Bar */}
                        <div
                            className="my-3 p-3"
                            style={{ backgroundColor: "#f0f0f0", borderRadius: "5px" }}
                        >
                            <div className="d-flex align-items-center">
                                <label
                                    style={{
                                        fontWeight: "bold",
                                        marginRight: "10px",
                                        fontSize: "18px",
                                    }}
                                >
                                    Search:
                                </label>
                                <input
                                    type="search"
                                    className="form-control"
                                    placeholder="Search"
                                    style={{ maxWidth: "200px" }}
                                />

                                {/* Buttons pushed to the right */}
                                <div className="ms-auto me-2">
                                    <button
                                        className="btn mx-2"
                                        style={{
                                            backgroundColor: "#004aad",
                                            color: "white",
                                        }}
                                    >
                                        Export
                                    </button>
                                    <Link to="/addCoupon">
                                        <button
                                            className="btn"
                                            style={{
                                                backgroundColor: "#004aad",
                                                color: "white",
                                            }}
                                        >
                                            + Add
                                        </button>
                                    </Link>
                                </div>
                            </div>

                            {/* Info message below */}
                            <span className="d-block mt-3">Showing 0 to 0 of 0 entries</span>
                        </div>

                        {/* Table */}
                        <table className="table table-striped">
                            <thead className="thead-light">
                                <tr>
                                    <th>Code</th>
                                    <th>Discount</th>
                                    <th>Max Uses</th>
                                    <th>Max Uses Per Practice</th>
                                    <th>Claims</th>
                                    <th>Expiry</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td colSpan="6" className="text-center">
                                        No data available in table
                                    </td>
                                </tr>
                            </tbody>
                        </table>

                        {/* Footer with Entries Message */}
                        <div className="d-flex justify-content-between align-items-center mt-3">
                            <span>Showing 0 to 0 of 0 entries</span>
                        </div>
                    </div>
                </div>

                <br />
                <br />
                <br />
                <br />
                <br />
                <br />
                <br />
                <br />
                <br />
                <br />
                <br />
                <br />
                <br /><br />
                <br />
                <br />
                <br />
                <div style={{width: '95%',  margin: '0 auto' ,padding:"0px"}}>
                <Footer />
                </div>
            </div>
        </>
    );
};

export default Coupon;
